const translations = {
    covered: 'Covered'
};

export default translations;
